import { render, staticRenderFns } from "./IconMyPagePresent.vue?vue&type=template&id=556ed3b8"
import script from "./IconMyPagePresent.vue?vue&type=script&lang=ts"
export * from "./IconMyPagePresent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports